<template>
    <div>
        <breadcrumbs-bar :breadcrumbs="breadcrumbs"/>

        <div class="page-help">
            <div class="page-help__title">
                <h1>{{ categoryTitle }}</h1>
            </div>
            <div class="page-help__body">
                <div class="page-help__list">
                    <ul>
                        <li v-for="item in helpItems">
                            <router-link :to="item.pageUrl">
                                <span v-text="item.question"/>
                                <svg width="11" height="18" viewBox="0 0 11 18" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path d="M1 17L9 9L0.999999 1" stroke="#926D20" stroke-width="2"/>
                                </svg>
                            </router-link>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="page-help__bottom">
                <div class="container">
                    <h2>{{ $t('front.help.titles.need_more_help') }}</h2>
                    <v-btn @click="supportDialog = true">{{ $t('front.help.button.contact_us') }}</v-btn>
                </div>
            </div>
        </div>

        <v-dialog content-class="dialog-support" v-model="supportDialog" max-width="900px" :persistent="isDialogPersistent">
            <support-popup @close="supportDialog = false" v-if="supportDialog"/>
        </v-dialog>
    </div>
</template>

<script>
import DialogSettings from "../../../../mixins/dialogSettings";
import apiData from "../../../../mixins/apiData";

export default {
    name: "HelpCategoryItemContent",

    mixins: [DialogSettings, apiData],

    data: function () {
        return {
            supportDialog: false,
        };
    },

    serverPrefetch() {
        return this.fetchData();
    },

    mounted() {
        this.fetchData();
    },

    computed: {
        category() {
            let slug = this.$route.params.slug;

            return slug && this.$store.state.helpCategories.find(category => category.slug === slug);
        },

        categoryTitle() {
            return this.category && this.category.title || '';
        },

        helpItems() {
            return this.category && this.category.items || [];
        },

        breadcrumbs() {
            let languageUrlPrefix = this.$store.getters.getLanguageUrlPrefix();

            return [
                {
                    text: this.$t('front.help.titles.help_center'),
                    disabled: false,
                    href: `${languageUrlPrefix}/help`,
                },
                {
                    text: this.categoryTitle,
                    disabled: false,
                    href: this.$route.path,
                },
            ];
        },
    },

    methods: {
        fetchData(){
            return this.$store.dispatch('FETCH_HELP_CATEGORIES', this.createApiData());
        },
    },
}
</script>

<style lang="sass">
@import "sass/components/pages/parts/target/HelpCategoryItemContent"
</style>